import { render, staticRenderFns } from "./lock-screen.vue?vue&type=template&id=48e8fc5a&"
import script from "./lock-screen.vue?vue&type=script&lang=js&"
export * from "./lock-screen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports